export const DOCUMENT_TYPE = {
  STANDARD: 'standard',
  ENTERPRISE: 'enterprise',
  DEVICE: 'device-calibration'
};

export const STEP = {
  SELECT_TYPE: 'select-type',
  SELECT_DEVICE: 'select-device',
  UPLOAD: 'upload',
  SELECT_DIRECTORY: 'select-directory',
  CONFIG: 'config',
  RESULTS: 'results'
};

export const UPLOAD_MODE = {
  FULL: 'full',
  SINGLE: 'single'
};

export const DEFAULT_FILTERS = {
  selectedLevel: '等级1',
};

export const NO_LEVEL_KEY = '无等级';

export const PREDEFINED_DIRECTORIES = [
  '电压法',
  '电流探头法',
  'ALSE法',
  '带状线法',
  '辐射发射法'
];

export const TRANSFORMATION_MAP = {
  original: { label: '原始数据', suffix: '原始数据' },
  opposite: { label: '相反数', suffix: '相反数' },
  absolute: { label: '正数', suffix: '正数' },
  negative: { label: '负数', suffix: '负数' }
};
